import { FunctionComponent } from 'react';
import * as Icons from '@spotnana/pixel-react/dist/Icons';
import { IconProps } from '@spotnana/pixel-react/dist/Icons/common';
import { UtaPolicyValueSeat } from 'obt-common';

const UnknownIcon = Icons.QuestionCircled;

const iconMap: { [key: string]: FunctionComponent<IconProps> } = {
  // Flight Amenities
  aircraft: Icons.Aircraft,
  power: Icons.Power,
  wifi: Icons.Wifi,
  flatbed: Icons.Flatbed,
  seat: Icons.SeatPitch,
  entertainment: Icons.Entertainment,
  beverage: Icons.Beverage,
  layout: Icons.SeatLayout,
  freshFood: UnknownIcon,
  cleaning: Icons.Cleaning,
  mask: Icons.Mask,
  temperatureCheck: Icons.Temperature,
  capacity: Icons.PassengerCapacity,
  blockedAdjacentSeats: Icons.BlockedAdjacentSeat,
  covidTesting: Icons.CovidTesting,
  vaccine: Icons.CovidVaccine,

  // Flight UTAs
  baggage: Icons.CarryOnBaggage,
  carryOn: Icons.CarryOnBaggageV2,
  baggageV4: Icons.CarryOnBaggageV4,
  checkedBag: Icons.Luggage,
  additionalCheckedBag: Icons.AdditionalLuggage,
  checkedBaggage: Icons.CheckInLuggage,
  additionalCheckedLugguage: Icons.AdditionalCheckedLugguage,
  cancellation: Icons.Refund,
  advanceChange: Icons.DateChange,
  sameDayChange: Icons.DateChange,
  seatSelection: Icons.CarSeat,
  checkInPriority: Icons.Ticket,
  boardingPriority: Icons.Ticket,
  safetyBaggage: Icons.CarryOnBaggageV3,
  upgradeEligibility: UnknownIcon,
  // TODO: loungeAccess icon will be changed into appropiate icon
  // once we have the icon available in the design system
  loungeAccess: Icons.CheckCircle,

  // fare type
  refundable: Icons.Refund,
  changeable: Icons.Change,
};

const seatIconMap = new Proxy(
  {
    [UtaPolicyValueSeat.STANDARD]: Icons.StandardSeat,
    [UtaPolicyValueSeat.RECLINER]: Icons.ReclinerSeat,
    [UtaPolicyValueSeat.ANGLE_FLAT]: Icons.AngleFlatSeat,
    [UtaPolicyValueSeat.FLAT]: Icons.LieFlatSeat,
    [UtaPolicyValueSeat.SUITE]: Icons.SuiteSeat,
    [UtaPolicyValueSeat.UNKNOWN]: UnknownIcon,
    [UtaPolicyValueSeat.UNRECOGNIZED]: UnknownIcon,
  },
  {
    get: (target, prop): React.FC<IconProps> => {
      // Typecasting is fine here since we are checking for existence, We can create a typeguard in future
      const icon = target[prop as unknown as UtaPolicyValueSeat];
      if (icon) {
        return icon;
      }

      return UnknownIcon;
    },
  },
);

export { seatIconMap };

export default new Proxy(iconMap, {
  get: (target, prop: string): FunctionComponent<IconProps> => {
    if (target[prop]) {
      return target[prop];
    }

    return UnknownIcon;
  },
});
